/*
 *  -----------------------------------------------------------------------
 *    <copyright file="settings.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

declare global {
    interface Window {
        // Injected at runtime by /settings/riskIqApiOrigin.js (per-environment; deploy pipeline
        // swaps the file, LOCAL default committed).
        riskIqApiOrigin?: string;
        // Injected at runtime by /settings/riskIqEnabled.js (per-environment; deploy pipeline
        // swaps the file, LOCAL default committed). Read via isRiskIqEnabled() only.
        riskIqEnabled?: boolean;
    }
}

interface ISettings {
    token: string | null;
    api: {
        graphQlUrl: () => string;
        restUrl: () => string;
        graphQlWebSocketUrl: () => string;
        url: () => string;
        webSocketUrl: () => string;
        reportingHubUrl: () => string;
        frontendMessageHubUrl: () => string;
        frontendMessageHubVersionUrl: () => string;
        // Absolute origin of RiskIQ's own API for this environment (embedded RiskIq component).
        // Empty string / unset when not yet supplied.
        riskIqApiOrigin: () => string;
    };
}

const Settings: ISettings = {
    token: null,
    api: {
        graphQlUrl: () => `${Settings.api.url()}/api/graphql`,

        graphQlWebSocketUrl: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol.toLowerCase() === 'http:' ? 'ws' : 'wss'}://${
                      window.location.hostname
                  }/graphql`
                : 'wss://localhost:44352/graphql',

        url: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol}//${window.location.hostname}`
                : 'https://localhost:44352',

        restUrl: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol}//${window.location.hostname}/bff-api`
                : 'https://localhost:4101/bff-api',

        webSocketUrl: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol.toLowerCase() === 'http:' ? 'ws' : 'wss'}://${window.location.hostname}`
                : 'wss://localhost:44352',

        reportingHubUrl: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol.toLowerCase() === 'http:' ? 'ws' : 'wss'}://${
                      window.location.hostname
                  }/bff-api`
                : 'wss://localhost:4101/bff-api',

        frontendMessageHubUrl: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol.toLowerCase() === 'http:' ? 'ws' : 'wss'}://${window.location.hostname}/frontend-message-hub`
                : 'wss://localhost:4201/frontend-message-hub',

        frontendMessageHubVersionUrl: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol}//${window.location.hostname}/frontend-message-hub/appVersion`
                : 'https://localhost:4201/frontend-message-hub/appVersion',

        riskIqApiOrigin: () => window.riskIqApiOrigin ?? '',
    },
};

export default Settings;
